import { BaseService } from "./base.service";
export class ProgramCriterionService extends BaseService {
  constructor() {
    super("program-criteria");
  }
}
